export default __webpack_public_path__ + "static/media/avatar_tommy9.b293cb56.mp3";